import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { WaybillCommentsModel, WaybillIdView } from '../../../../models';
import {
  ShipmentWaybillCommentsInitialState,
  ShipmentWaybillCommentsLoad,
  ShipmentWaybillCommentsSave,
} from './shipment-waybill-comments.actions';
import { ShipmentWaybillCommentsState } from './shipment-waybill-comments.state';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillCommentsFacade implements LoadDataFacade, SetInitialStateFacade {
  comments$: Observable<WaybillCommentsModel[]> = this.store.select(ShipmentWaybillCommentsState.getComments);
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillCommentsState.getLoaded);

  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillCommentsLoad(identifier));
  }

  saveWaybillComment(identifier: WaybillIdView, comment: string): void {
    this.store.dispatch(new ShipmentWaybillCommentsSave({ waybill: identifier, comment }));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillCommentsInitialState());
  }
}
